import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5bb526ba&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5bb526ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb526ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb526ba')) {
      api.createRecord('5bb526ba', component.options)
    } else {
      api.reload('5bb526ba', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5bb526ba&scoped=true&", function () {
      api.rerender('5bb526ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Nk2pB25aMWce/JS/comp/GuestBox.vue"
export default component.exports